export * from './link-footer-item.interface';
export * from './link-footer-subitem.interface';
